// AboutHelp.js
import React from 'react';
import VisitOMSLogo from './VisitOMS_logo.png';

function AboutHelp() {
  // Ako baš želiš da razlikuješ prikaz po roli:
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const role = user.role || 'teacher';

  return (
    <div className="max-w-3xl mx-auto space-y-6">
      {/* LOGO */}
      <div className="flex flex-col items-center text-center mb-4">
        <img
          src={VisitOMSLogo}
          alt="VisitOMS logo"
          className="w-32 h-32 md:w-40 md:h-40 object-contain mb-3"
        />
        <h1 className="text-2xl font-bold">VisitOMS EasyCare</h1>
        <p className="text-sm text-gray-500 mt-1">Version v1.0</p>
      </div>

      {/* COMPANY INFO */}
      <section className="bg-white shadow rounded-lg p-4 md:p-6">
        <h2 className="text-xl font-semibold mb-2">About VisitOMS</h2>
        <p className="text-sm text-gray-700 mb-2">
          VisitOMS is a software solution focused on managing home-based visits for children
          aged 0–36 months within Early Intervention (EI) and Project Impact (PI) programs.
          The platform is designed to support agencies, administrators, and providers who work
          directly with families in the field.
        </p>
        <p className="text-sm text-gray-700 mb-2">
          The system combines visit scheduling, smart teacher assignment, geolocation and routing,
          time logging, skill tracking, and reporting into one integrated workflow. It is built with
          real-world constraints in mind: traffic, availability, cost optimization, and compliance
          with program rules.
        </p>

        <div className="mt-4 border-t pt-4">
          <h3 className="text-md font-semibold mb-1">Company details</h3>
          <p className="text-sm text-gray-700">
            <span className="font-medium">Company name:</span> VisitOMS / Weather2Umbrella Group
          </p>
          <p className="text-sm text-gray-700">
            <span className="font-medium">Project name:</span> VisitOMS EasyCare
          </p>
          <p className="text-sm text-gray-700">
            <span className="font-medium">Address:</span>{' '}
            <span className="italic text-gray-500">
              [Add your official company address here]
            </span>
          </p>
          <p className="text-sm text-gray-700">
            <span className="font-medium">Contact email:</span>{' '}
            <span className="italic text-gray-500">
              [Add your official support email here]
            </span>
          </p>
        </div>
      </section>

      {/* PROJECT INFO */}
      <section className="bg-white shadow rounded-lg p-4 md:p-6">
        <h2 className="text-xl font-semibold mb-2">About the EasyCare project</h2>
        <p className="text-sm text-gray-700 mb-2">
          EasyCare was created as a practical tool to support agencies working with infants and
          toddlers in the 0–36 months range. The goal is to replace fragmented spreadsheets,
          manual planning, and paper-based time logs with one coherent system that can grow
          with the organization.
        </p>
        <p className="text-sm text-gray-700 mb-2">
          The platform is optimized for:
        </p>
        <ul className="list-disc list-inside text-sm text-gray-700 space-y-1">
          <li>Daily and weekly visit planning for EI and PI programs.</li>
          <li>
            Automatic suggestions for substitute providers when the default teacher is unavailable.
          </li>
          <li>Objective route calculations using geolocation and routing APIs.</li>
          <li>Detailed time logs for billing, payroll, and internal analytics.</li>
          <li>Tracking child skills and progress over time with structured evaluations.</li>
        </ul>

        <p className="text-sm text-gray-700 mt-3">
          Depending on your role, you will see different parts of the system:
        </p>
        <ul className="list-disc list-inside text-sm text-gray-700 space-y-1">
          <li>
            <span className="font-medium">Administrators</span> focus on agency-wide settings,
            teacher management, scheduling, and reporting.
          </li>
          <li>
            <span className="font-medium">Teachers / Providers</span> focus on their own visits,
            day planning, time logs, and child skill tracking.
          </li>
        </ul>
      </section>

      {/* ROLE-SPECIFIC HELP (kratko) */}
      <section className="bg-white shadow rounded-lg p-4 md:p-6">
        <h2 className="text-xl font-semibold mb-2">Quick help</h2>
        {role === 'admin' ? (
          <ul className="list-disc list-inside text-sm text-gray-700 space-y-1">
            <li>
              Start in <span className="font-medium">Dashboard</span> for a quick overview.
            </li>
            <li>
              Use <span className="font-medium">Manage Teachers</span> and{' '}
              <span className="font-medium">Manage Students</span> to keep your data clean.
            </li>
            <li>
              Plan visits in <span className="font-medium">Manage Visits</span> and{' '}
              <span className="font-medium">Smart Visits Scheduler</span>.
            </li>
            <li>
              Check KPIs in <span className="font-medium">Teachers Work Report</span> and{' '}
              <span className="font-medium">Teacher Time Logs</span>.
            </li>
          </ul>
        ) : (
          <ul className="list-disc list-inside text-sm text-gray-700 space-y-1">
            <li>
              Each day, start with <span className="font-medium">My Day Planner</span> and{' '}
              <span className="font-medium">My Visits</span>.
            </li>
            <li>
              Use <span className="font-medium">Check-in</span> and{' '}
              <span className="font-medium">Check-out</span> with geolocation when you visit a family.
            </li>
            <li>
              Update child skills in <span className="font-medium">My Students Skills</span> and{' '}
              <span className="font-medium">Student Goals &amp; Achievement</span>.
            </li>
            <li>
              Review your hours and travel in <span className="font-medium">My Time Log</span>.
            </li>
          </ul>
        )}
      </section>
    </div>
  );
}

export default AboutHelp;
